export function farehelper(distance,time,rateDetails){
    let ratePerKm = rateDetails.rate_per_kilometer;
    let ratePerHour = rateDetails.rate_per_hour;
    let ratePerSecond = ratePerHour/3600;
    let minFare =  rateDetails.min_fare;
    let DistanceInKM = parseFloat(distance/1000).toFixed(1);
    let estimateRateForKM = Math.ceil(parseFloat(DistanceInKM*ratePerKm).toFixed(0)*1 / 10) * 10;
    let estimateRateForhour = Math.ceil(parseFloat(time*ratePerSecond).toFixed(0) / 10) * 10;
    let total = ((Math.ceil(parseFloat(estimateRateForKM).toFixed(0) / 10) * 10)+Math.ceil(parseFloat(estimateRateForhour).toFixed(0) / 10) * 10)>minFare?(parseFloat(estimateRateForKM)+parseFloat(estimateRateForhour)):minFare;

    let convenienceFee = (total*rateDetails.convenience_fees/100);
    

    let grandtotal = Math.ceil(parseFloat(total).toFixed(0) / 10) * 10+Math.ceil(parseFloat(convenienceFee).toFixed(0) / 10) * 10;
    let calculateData = {
        distaceRate:estimateRateForKM,
        timeRate:estimateRateForhour,
        totalCost:total,grandTotal:grandtotal,
        convenience_fees:convenienceFee}
        
    return calculateData
}
